import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { chatApiClient } from '../chatApiClient';
import type { ChatInbox } from '../utils/chat';
import { CHAT_UNREAD_COUNT_CHANGED_EVENT } from '../utils/chatUnreadCount';

export function useChatUnreadCount(enabled: boolean, inbox: ChatInbox): number {
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled) {
      setUnreadCount(0);
      return;
    }

    try {
      const response = await chatApiClient.getUnreadCount(inbox);
      setUnreadCount(Math.max(0, response.unreadCount ?? 0));
    } catch {
      // Nav badge is non-critical; keep the last known count on transient errors.
    }
  }, [enabled, inbox]);

  useEffect(() => {
    void refresh();
  }, [refresh, location.pathname]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const handleChange = () => {
      void refresh();
    };

    window.addEventListener(CHAT_UNREAD_COUNT_CHANGED_EVENT, handleChange);
    return () => window.removeEventListener(CHAT_UNREAD_COUNT_CHANGED_EVENT, handleChange);
  }, [enabled, refresh]);

  return unreadCount;
}
